import * as React from 'react'
import styled from 'styled-components'

import { lightweight, standalone, SymbolProps } from '../../spritesheetUtils'
import { Icon } from '../Icon'
import { SpecificIconProps } from '../types'

const PERCENT_PATH = (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.747 26.14a4.33 4.33 0 1 0 0-8.659 4.33 4.33 0 0 0 0 8.658Zm0 1.48a5.81 5.81 0 1 0 0-11.62 5.81 5.81 0 0 0 0 11.62Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.747 25.472a3.662 3.662 0 1 0 0-7.324 3.662 3.662 0 0 0 0 7.324Zm6.478-3.662a6.478 6.478 0 1 1-12.955 0 6.478 6.478 0 0 1 12.955 0Zm-2.149 0a4.33 4.33 0 1 1-8.658 0 4.33 4.33 0 0 1 8.658 0Zm1.481 0a5.81 5.81 0 1 1-11.62 0 5.81 5.81 0 0 1 11.62 0ZM10.19 12.582a4.33 4.33 0 1 0 0-8.658 4.33 4.33 0 0 0 0 8.658Zm0 1.481a5.81 5.81 0 1 0 0-11.62 5.81 5.81 0 0 0 0 11.62Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.19 11.915a3.662 3.662 0 1 0 0-7.324 3.662 3.662 0 0 0 0 7.324Zm6.477-3.662a6.478 6.478 0 1 1-12.955 0 6.478 6.478 0 0 1 12.955 0Zm-2.148 0a4.33 4.33 0 1 1-8.659 0 4.33 4.33 0 0 1 8.659 0Zm1.48 0a5.81 5.81 0 1 1-11.62 0 5.81 5.81 0 0 1 11.62 0Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.044 28.36H4.38a.74.74 0 0 1-.74-.74v-6.664a.74.74 0 1 1 1.48 0v4.877L27.097 3.856a.74.74 0 1 1 1.047 1.047L6.167 26.88h4.877a.74.74 0 0 1 0 1.48Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.044 29.028H4.38c-.777 0-1.407-.63-1.407-1.408v-6.664a1.408 1.408 0 1 1 2.815 0v3.265L26.625 3.384a1.408 1.408 0 0 1 1.99 1.991L7.78 26.212h3.265a1.408 1.408 0 1 1 0 2.816Zm0-2.148a.74.74 0 0 1 0 1.48l-6.665.001a.74.74 0 0 1-.74-.74v-6.665a.74.74 0 1 1 1.481 0v4.877L27.097 3.856a.74.74 0 0 1 1.047 1.047L6.167 26.88h4.877Z"
    />{' '}
  </g>
)

const ID = 'percent-stroke-glyph-icon'

export function PercentSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 30 30">
      {PERCENT_PATH}
    </symbol>
  )
}

const PercentStandaloneContent = standalone(PercentSymbol, ID)

export const Percent = styled(function PercentComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="percent">
      <PercentStandaloneContent />
    </Icon>
  )
})``

export const PercentLightweight = styled(function PercentComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="percent-light-weight">
      {lightweight(ID)}
    </Icon>
  )
})``
